<span class="member-tile {{tileSize}}"
      title="{{tile.title}}"
      style="background-color: {{tile.color}}"
      [ngClass]="{ 'hidden': tile.hidden }">
  {{tile.text}}
</span>